import React, { useEffect, useState } from "react";
import "./GlassLogin.css"; // External CSS for cleaner JSX
import { useLocation, useNavigate } from "react-router-dom";
import Particle from "../Particle";
import axios from "axios";

const GlassLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  useEffect(()=>{
    if(localStorage.getItem("IsLogged")=="True"){
        navigate('/Home');
    }
  })

  const handleLogin = async () => {
    const response = await axios
      .post("https://portfolio-server-91pj.onrender.com/login", {
        UserName: username,
        Password: password,
      })
      .then((response) => {
        localStorage.setItem("IsLogged", "True");
        console.log(response)
        localStorage.setItem("Token",response.data.token)
        window.location.reload();
        setMessage("Login successful!");
      })
      .catch((error) => {
        setMessage("Invalid credentials");
      });
  };

  return (
    <div className="login-body">
      <Particle />
      <div className="glass-container">
        <h2>Login</h2>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button onClick={handleLogin}>Login</button>
        <div className={message === "Login successful!" ? "success" : "error"}>
          {message}
        </div>
      </div>
    </div>
  );
};

export default GlassLogin;
